import { NgModule } from '@angular/core';
import { RouterModule, Routes, TitleStrategy } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { WelcomeComponent } from '@connect/components/welcome/welcome.component';
import { ConnectTitleStrategyProvider } from '@connect/shared/providers/connect-title-strategy.provider';
import { ContactService } from './contact/services/contact.service';
import { LookupService } from './secure/services/lookup.service';
import { ClientService } from './contact/services/client.service';
import { BaseHttpClientService } from './shared/services/base-http-client.service';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { routes } from './../routes/routes'

/*
const routes: Routes = [
    { path: '', component: WelcomeComponent },
    { path: 'app', loadChildren: () => import('@connect/secure/secure-routing.module').then(m => m.SecureRoutingModule) },
    { path: 'public', loadChildren: () => import('@connect/public/public-routing.module').then(m => m.PublicRoutingModule )},
    { path: 'unauthorized', component: UnauthorizedComponent }
];
*/

@NgModule({
    declarations: [
        WelcomeComponent
    ],
    exports: [
        RouterModule
    ],
    imports: [
        RouterModule.forRoot(routes),
        FormsModule
    ],
    providers: [
        {
            provide: TitleStrategy,
            useClass: ConnectTitleStrategyProvider
        },
        ContactService,
        LookupService,
        ClientService,
        BaseHttpClientService
    ]
})
export class AppRoutingModule {
    constructor() {
        console.log(routes);
    }
}
